import Layout from '@src/components/layout/Layout';
import { Typography } from '@mui/material';
import ConsultantList from './components/ConsultantList';

function ScanReview() {
  return (
    <Layout>
      <Typography variant="h4">Scan Review</Typography>
      <ConsultantList />
    </Layout>
  );
}

export default ScanReview;
